import moment from 'moment';

export const formatExactDateTime = (timestamp, locale = 'es') => {
  if (!timestamp) return '';
  moment.locale(locale);
  return moment(timestamp).format('DD/MM/YYYY HH:mm:ss');
};

export const formatDate = (timestamp, locale = 'es') => {
  if (!timestamp) return '';
  moment.locale(locale);
  return moment(timestamp).format('DD/MM/YYYY');
};

export const formatRelativeTime = (timestamp, locale = 'es') => {
  if (!timestamp) return '';
  moment.locale(locale);
  return moment(timestamp).fromNow();
};

export const formatNativeDateTime = (timestamp, locale = 'es-ES', options = {}) => {
  if (!timestamp) return '';
  const defaultOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };
  return new Date(timestamp).toLocaleString(locale, { ...defaultOptions, ...options });
};

export default {
  formatExactDateTime,
  formatDate,
  formatRelativeTime,
  formatNativeDateTime,
};

